import { apiRequest } from './queryClient';

export interface LandingPageSection {
  _id: string;
  section: string;
  content: any;
  isActive: boolean;
  updatedBy?: string;
  updatedAt: string;
  createdAt: string;
}

export const landingPageApi = {
  // Public endpoints
  getAllContent: async () => {
    return await apiRequest('GET', '/api/landing-page/content');
  },

  getSectionContent: async (section: string) => {
    return await apiRequest('GET', `/api/landing-page/content/${section}`);
  },

  // Admin endpoints
  getAllSections: async () => {
    return await apiRequest('GET', '/api/landing-page/admin/content');
  },

  updateSection: async (section: string, data: { content: any; isActive?: boolean }) => {
    return await apiRequest('PUT', `/api/landing-page/admin/content/${section}`, data);
  },

  toggleSection: async (section: string) => {
    return await apiRequest('PATCH', `/api/landing-page/admin/content/${section}/toggle`);
  },

  deleteSection: async (section: string) => {
    return await apiRequest('DELETE', `/api/landing-page/admin/content/${section}`);
  },
};
